export default function BootTradeInFooterSection() {
  return (
    <div className="flex w-full bg-[#F5F5F5] px-8 py-16 sm:mx-auto sm:px-[15rem]">
      <div className="flex flex-col gap-y-8">
        <h3 className="text-[2.1rem] font-semibold text-black">
          MX Locker Boot Trade-In Program – Upgrade Your Boots & Save
        </h3>

        <p className="text-[1.8rem] font-medium text-[#444444]">
          Looking to upgrade your motocross boots? With the MX Locker Boot
          Trade-In Program, you can trade in your used boots and get credit
          toward a new pair. Whether you’re upgrading to the latest Alpinestars,
          Fox Racing, or Gaerne boots, our program makes it easy to save while
          keeping quality gear in circulation. Simply upload photos, choose your
          preferred upgrade, and receive a trade-in offer. Get the most value
          for your used dirt bike boots while ensuring another rider gets access
          to affordable, high-quality gear. Start your trade-in today and step
          into a better ride!
        </p>
      </div>
    </div>
  );
}
